module.exports = __webpack_public_path__ + "img/kakao.9a55ff9d.png";